/**
 * Keyclic API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.24.5
 * Contact: techies@keyclic.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Category } from '../model/category';
import { CategoryData } from '../model/categoryData';
import { CategoryPagination } from '../model/categoryPagination';
import { CategoryPatch } from '../model/categoryPatch';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { CategoryServiceInterface }                            from './category.serviceInterface';


@Injectable()
export class CategoryService implements CategoryServiceInterface {

    protected basePath = 'https://api.keyclic.com';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Retrieve all Category resources.
     * 
     * @param x_keyclic_app 
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param business_activity The identifier of the resource formatted as GUID string.
     * @param organization The identifier of the resource formatted as GUID string.
     * @param geo_coordinates One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param geo_point One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param search_color 
     * @param search_icon 
     * @param search_name 
     * @param search_identificationNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetCategories(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, organization?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<CategoryPagination>;
    public cgetCategories(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, organization?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CategoryPagination>>;
    public cgetCategories(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, organization?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CategoryPagination>>;
    public cgetCategories(x_keyclic_app: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, organization?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetCategories.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (business_activity !== undefined && business_activity !== null) {
            queryParameters = queryParameters.set('business_activity', <any>business_activity);
        }
        if (organization !== undefined && organization !== null) {
            queryParameters = queryParameters.set('organization', <any>organization);
        }
        if (geo_coordinates !== undefined && geo_coordinates !== null) {
            queryParameters = queryParameters.set('geo_coordinates', <any>geo_coordinates);
        }
        if (geo_point !== undefined && geo_point !== null) {
            queryParameters = queryParameters.set('geo_point', <any>geo_point);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }
        if (search_color !== undefined && search_color !== null) {
            queryParameters = queryParameters.set('search[color]', <any>search_color);
        }
        if (search_icon !== undefined && search_icon !== null) {
            queryParameters = queryParameters.set('search[icon]', <any>search_icon);
        }
        if (search_name !== undefined && search_name !== null) {
            queryParameters = queryParameters.set('search[name]', <any>search_name);
        }
        if (search_identificationNumber !== undefined && search_identificationNumber !== null) {
            queryParameters = queryParameters.set('search[identificationNumber]', <any>search_identificationNumber);
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<CategoryPagination>(`${this.basePath}/categories`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve all Category resources.
     * 
     * @param x_keyclic_app 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param business_activity The identifier of the resource formatted as GUID string.
     * @param geo_coordinates One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param geo_point One latitude and one longitude serialized and separated by a plus or a minus sign.
     * @param page Page of the overview.
     * @param limit Page of the overview.
     * @param order 
     * @param after 
     * @param before 
     * @param search_color 
     * @param search_icon 
     * @param search_name 
     * @param search_identificationNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public cgetCategoriesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<CategoryPagination>;
    public cgetCategoriesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CategoryPagination>>;
    public cgetCategoriesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CategoryPagination>>;
    public cgetCategoriesByOrganization(x_keyclic_app: string, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, business_activity?: string, geo_coordinates?: string, geo_point?: string, page?: number, limit?: number, order?: 'asc' | 'desc', after?: Date, before?: Date, search_color?: string, search_icon?: string, search_name?: string, search_identificationNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling cgetCategoriesByOrganization.');
        }
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling cgetCategoriesByOrganization.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (business_activity !== undefined && business_activity !== null) {
            queryParameters = queryParameters.set('business_activity', <any>business_activity);
        }
        if (geo_coordinates !== undefined && geo_coordinates !== null) {
            queryParameters = queryParameters.set('geo_coordinates', <any>geo_coordinates);
        }
        if (geo_point !== undefined && geo_point !== null) {
            queryParameters = queryParameters.set('geo_point', <any>geo_point);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }
        if (order !== undefined && order !== null) {
            queryParameters = queryParameters.set('order', <any>order);
        }
        if (after !== undefined && after !== null) {
            queryParameters = queryParameters.set('after', <any>after.toISOString());
        }
        if (before !== undefined && before !== null) {
            queryParameters = queryParameters.set('before', <any>before.toISOString());
        }
        if (search_color !== undefined && search_color !== null) {
            queryParameters = queryParameters.set('search[color]', <any>search_color);
        }
        if (search_icon !== undefined && search_icon !== null) {
            queryParameters = queryParameters.set('search[icon]', <any>search_icon);
        }
        if (search_name !== undefined && search_name !== null) {
            queryParameters = queryParameters.set('search[name]', <any>search_name);
        }
        if (search_identificationNumber !== undefined && search_identificationNumber !== null) {
            queryParameters = queryParameters.set('search[identificationNumber]', <any>search_identificationNumber);
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<CategoryPagination>(`${this.basePath}/organizations/${encodeURIComponent(String(organization))}/categories`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Retrieve one Category resource.
     * 
     * @param x_keyclic_app 
     * @param category The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCategory(x_keyclic_app: string, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Category>;
    public getCategory(x_keyclic_app: string, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Category>>;
    public getCategory(x_keyclic_app: string, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Category>>;
    public getCategory(x_keyclic_app: string, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling getCategory.');
        }
        if (category === null || category === undefined) {
            throw new Error('Required parameter category was null or undefined when calling getCategory.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];

        return this.httpClient.get<Category>(`${this.basePath}/categories/${encodeURIComponent(String(category))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Edit one Category resource.
     * 
     * @param x_keyclic_app 
     * @param CategoryPatch 
     * @param category The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchCategory(x_keyclic_app: string, CategoryPatch: CategoryPatch, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Category>;
    public patchCategory(x_keyclic_app: string, CategoryPatch: CategoryPatch, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Category>>;
    public patchCategory(x_keyclic_app: string, CategoryPatch: CategoryPatch, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Category>>;
    public patchCategory(x_keyclic_app: string, CategoryPatch: CategoryPatch, category: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling patchCategory.');
        }
        if (CategoryPatch === null || CategoryPatch === undefined) {
            throw new Error('Required parameter CategoryPatch was null or undefined when calling patchCategory.');
        }
        if (category === null || category === undefined) {
            throw new Error('Required parameter category was null or undefined when calling patchCategory.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<Category>(`${this.basePath}/categories/${encodeURIComponent(String(category))}`,
            CategoryPatch,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create one Category resource.
     * 
     * @param x_keyclic_app 
     * @param CategoryData 
     * @param organization The identifier of the resource formatted as GUID string.
     * @param accept_language 
     * @param x_keyclic_app_version 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public postCategoryByOrganization(x_keyclic_app: string, CategoryData: CategoryData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'body', reportProgress?: boolean): Observable<Category>;
    public postCategoryByOrganization(x_keyclic_app: string, CategoryData: CategoryData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Category>>;
    public postCategoryByOrganization(x_keyclic_app: string, CategoryData: CategoryData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Category>>;
    public postCategoryByOrganization(x_keyclic_app: string, CategoryData: CategoryData, organization: string, accept_language?: 'fr-FR' | 'en-US', x_keyclic_app_version?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (x_keyclic_app === null || x_keyclic_app === undefined) {
            throw new Error('Required parameter x_keyclic_app was null or undefined when calling postCategoryByOrganization.');
        }
        if (CategoryData === null || CategoryData === undefined) {
            throw new Error('Required parameter CategoryData was null or undefined when calling postCategoryByOrganization.');
        }
        if (organization === null || organization === undefined) {
            throw new Error('Required parameter organization was null or undefined when calling postCategoryByOrganization.');
        }

        let headers = this.defaultHeaders;
        if (accept_language !== undefined && accept_language !== null) {
            headers = headers.set('accept-language', String(accept_language));
        }
        if (x_keyclic_app !== undefined && x_keyclic_app !== null) {
            headers = headers.set('x-keyclic-app', String(x_keyclic_app));
        }
        if (x_keyclic_app_version !== undefined && x_keyclic_app_version !== null) {
            headers = headers.set('x-keyclic-app-version', String(x_keyclic_app_version));
        }

        // authentication (bearer) required
        if (this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/hal+json;charset=UTF-8'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json;charset=UTF-8'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Category>(`${this.basePath}/organizations/${encodeURIComponent(String(organization))}/categories`,
            CategoryData,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
